<template>
  <div>
    <div class>
      <div class="col-12">
        <b-navbar toggleable="lg" type="dark" variant>
          <b-navbar-brand :href="this.$store.state.homeurl">
            <img class="img-fluid" src="./../assets/imgs/logo-iee.png" alt="IEE Servicios Académicos" />
            <div class="negro leyenda">IEE INSTITUTO DE ESPECIALIZACIÓN PARA EJECUTIVOS</div>
          </b-navbar-brand>

          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

          <b-collapse id="nav-collapse" is-nav>
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
              <!-- <b-nav-item to="/">Nosotros</b-nav-item>
              <b-nav-item to="/">Servicios</b-nav-item>
              <b-nav-item to="/">Contacto</b-nav-item>-->
              <b-nav-item>
                <div>
                  <i class="fas fa-user-circle"></i>
                  {{this.matriculaadmin}}
                </div>
                <div>{{this.nombre}}</div>
              </b-nav-item>

              <b-nav-item class="d-none d-lg-block">|</b-nav-item>

              <b-nav-item title="Cerrar sesión" @click="logout()">
                <i class="fas fa-power-off"></i>
              </b-nav-item>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  /*props: {
    msg: String
  }*/ data() {
    return {
      matriculaadmin: "",
      nombre: ""
    };
  },
  mounted: function() {
    if (this.$cookie.get("useriee")) {
      this.$store.state.user = JSON.parse(this.$cookie.get("useriee"));
      this.matriculaadmin = this.$store.state.user.matricula;
      this.nombre = this.$store.state.user.nombre;
    }
  },
  methods: {
    logout() {
      this.$cookie.delete("useriee");
      this.$router.push("/");
    }
  }
};
</script>

